export default {"src":"/_next/static/media/shipping-needs.4c3b2119.svg","height":32,"width":33};